import React from "react";
import bannerImg from "../../assets/images/BecomeAListener/BecomeAnEmpatheticListenerBannerImg.webp";
import "./index.css";

export const BecomeAListenerBanner = () => {
  return (
    <div className="BecomeAListenerBannerSection">
      <div className="banner-heading">Become an Empathetic Listener</div>
      <div className="banner-desc">
        Make a meaningful impact by offering empathetic, confidential support to
        those who need it most. Train, get certified, and join as a Standard,
        Senior, or Expert Listener—helping others online or in-person.
      </div>

      <div className="banner-grid-section">
        {/* Left Side Image */}
        <div className="banner-grid-left">
          <img src={bannerImg} alt="Become a Listener" />
        </div>

        {/* Right Side Content */}
        <div className="banner-grid-right">
          <div className="grid-right-heading">
            Master the art of listening with compassion and turn it into a
            profession. In just 4 weeks, you'll learn how to:
          </div>
          <div className="grid-right-list">
            <ul>
              <li>Create safe spaces for others</li>
              <li>Handle sensitive conversations with care</li>
              <li>
                And the most powerful secret of empathetic listening… will only
                be revealed during the training.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
